"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabInner = exports.Tab = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _bumaga = require("./bumaga.tabs");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c897c5531{box-sizing:border-box;display:flex}.c897c5531:not(.ccae61bfc):not(.cef773d11){cursor:pointer}.c755ad674{position:relative;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.ccd1a6e25{position:relative;padding:1.375rem 1.5625rem;min-height:3.75rem;min-width:14.375rem;font-size:.875rem;font-weight:500;line-height:1rem;color:var(--color-flomni-gray-70)}.ccd1a6e25 .ccac59e53{display:none}.ccd1a6e25:not(.ccae61bfc):not(.cef773d11):hover{opacity:.7}.ccd1a6e25.cef773d11{color:var(--color-flomni-blue-70)}.ccd1a6e25.cef773d11:after{top:0;right:0;content:'';position:absolute;left:0;height:.25rem;background:var(--color-flomni-blue-70);border-radius:.125rem}.ccd1a6e25.ccae61bfc{opacity:.4}.c3566a5ea{position:relative;padding:1.375rem 3.125rem 1.375rem 0;min-height:3.75rem;min-width:14.375rem;font-size:.875rem;font-weight:500;line-height:1rem;color:var(--color-flomni-gray-70)}.c3566a5ea .ccac59e53{display:none}.c3566a5ea:not(.ccae61bfc):not(.cef773d11):hover{opacity:.7}.c3566a5ea.cef773d11{color:var(--color-flomni-blue-70)}.c3566a5ea.cef773d11:after{bottom:0;right:3.125rem;content:'';position:absolute;left:0;height:.25rem;background:var(--color-flomni-blue-70);border-radius:.125rem}.c3566a5ea.ccae61bfc{opacity:.4}.c7f4532ef{padding:0 1.25rem .4375rem 0;min-height:1.75rem;align-items:center}.c7f4532ef .cc135cb37{color:var(--color-gray-70);font-size:.875rem;font-weight:500;line-height:1.25rem;position:relative}.c7f4532ef .ccac59e53{padding-left:.25rem;display:flex}.c7f4532ef:not(.ccae61bfc):not(.cef773d11):hover .cc135cb37{color:var(--color-gray-90)}.c7f4532ef.cef773d11 .cc135cb37{color:var(--color-blue-90)}.c7f4532ef.cef773d11 .cc135cb37:after{content:'';bottom:-.5rem;right:0;left:0;height:.125rem;position:absolute;background:var(--color-blue-90);border-radius:.0625rem}.c7f4532ef.ccae61bfc{opacity:.5}");
var styles = {
  root: 'c897c5531',
  '--disabled': 'ccae61bfc',
  '--active': 'cef773d11',
  wrapper: 'c755ad674',
  '--view-usual': 'ccd1a6e25',
  label: 'ccac59e53',
  '--view-child': 'c3566a5ea',
  '--view-secondary': 'c7f4532ef',
  body: 'cc135cb37'
};
/* prevent props errors on init */

var Tab = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(TabInner, (0, _extends2.default)({}, props, {
    ref: ref
  }));
});
exports.Tab = Tab;
var TabInner = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
      classes = props.classes,
      disabled = props.disabled,
      view = props.view,
      label = props.label,
      maxWidth = props.maxWidth;

  var _useTabState = (0, _bumaga.useTabState)(children),
      isActive = _useTabState.isActive,
      onClick = _useTabState.onClick;

  var cn = (0, _useStyles.useStyles)(styles, classes);
  var onClickHandler = (0, _react.useCallback)(function () {
    if (disabled) return;
    onClick.apply(void 0, arguments);
  }, [disabled, onClick]);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClickHandler,
    className: (0, _classnames.default)(cn.root, cn.view[view], (0, _defineProperty2.default)({}, cn.active, isActive), (0, _defineProperty2.default)({}, cn.disabled, disabled)),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.body
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.wrapper,
    style: {
      maxWidth: maxWidth
    }
  }, children)), !label ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.label
  }, label));
});
exports.TabInner = TabInner;
TabInner.propTypes = {
  children: _propTypes.node.isRequired,
  label: _propTypes.node,
  disabled: _propTypes.bool,
  classes: (0, _getClassesPropType.getClassesPropType)(styles),
  view: _propTypes.string.isRequired,
  maxWidth: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
};
TabInner.defaultProps = {
  disabled: false,
  classes: {},
  label: null,
  maxWidth: 'unset'
};